import React, { useContext } from 'react'
import { OrderLeft, OrderCancel } from '../../Icons/OrderDefined'
import { LanguageContext } from '../../../contexts/LanguageContext'

export default function MyNavBar2 (props) {
  const Language = useContext(LanguageContext)
  const leftContentVisible = props.leftContentVisible === false ? props.leftContentVisible : true // 是否显示左侧图标，默认为true
  const rightContentVisible = props.rightContentVisible === false ? props.rightContentVisible : false // 是否显示右侧图标，默认为false
  return (
    <ul style={props.style || {}} className='h43 pl5 vc'>
      <li className='w8' onClick={props.leftClick || props.history.goBack}>
        {!leftContentVisible ? <div /> : props.Icon ? props.Icon : <OrderLeft color={'#fff'} width={'14'} height={'14'} />}
      </li>
      <li style={props.titleStyle || {}} className={'w82 pb4 tl fs16 gf' + (Language.locale === 'en' ? '' : ' lt1-5')}>{props.children}</li>
      <li className='w10' onClick={props.rightClick || props.history.goBack}>
        {!rightContentVisible ? <div /> : props.rightContent ? props.rightContent : <OrderCancel color={'#fff'} width={'14'} height={'14'} />}
      </li>
    </ul>
  )
}
